import React from 'react';
import PageWrapper from '../../components/UI/PageWrapper';
import Surveys from '../../components/Admin/Surveys/Surveys';

const SurveysPage = () => (
  <PageWrapper>
    <Surveys />
  </PageWrapper>
);

export default SurveysPage;
